import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Tab = props => {
  const { title, active, onClick, className } = props;

  const isActive = active ? 'tab--active' : '';
  const classname = classnames('tab', 'col', className, isActive);

  return (
    <li className={classname}>
      <button
        role='tab'
        type='button'
        aria-selected={active}
        onClick={onClick}
        className='tab__text'
      >
        {title}
      </button>
    </li>
  );
};

Tab.propTypes = {
  title: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string
};

Tab.defaultProps = {
  active: false,
  className: ''
};

export default Tab;
